export enum ELocalStorageItems {
    dexForRedirect = 'dexForRedirect',
    dexRedirectLink = 'dexRedirectLink',
}
